<template>
<div class="education">

  <ExperienceTemplate :pageTitle="$t('education.education')" :Experiences="Education" :experienceIcon="educationImage"/>
  
</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import EducationEn from '@/components/Helpers/About/Education/EducationEn.js';
import EducationPt from '@/components/Helpers/About/Education/EducationPt.js';
import ExperienceTemplate from '@/components/Helpers/ExperienceTemplate.vue'
import educationImage from "@/assets/about/education.png"

const Education = ref(null);

onMounted(() => {
  const userLanguage = navigator.language || navigator.userLanguage;

  if (userLanguage.startsWith("pt")) {
    Education.value = EducationPt;
  }
  else {
    Education.value = EducationEn;
  }
});

</script>

<style lang="scss" scoped>
.education {
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  padding-bottom: 20px;
  margin-top: -40px;
  margin-bottom: 50px;
}
</style>